import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import ImageViewer from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/image_viewer/image_diff_viewer_with_discussions.vue?vue3';
import { commitDiffDiscussionsStore } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/stores/instances/commit_discussions.js?vue3';
import { MOUNTED } from '../adapter_events';

export const commitImageViewerAdapter = {
  [MOUNTED]() {
    const imageData = JSON.parse(
      this.diffElement.querySelector('[data-image-data]').dataset.imageData,
    );
    const { oldPath, newPath, diffRefs } = this.data;
    const { appData } = this;
    initVueApp({
      el: this.diffElement.querySelector('[data-image-view]'),
      name: 'ImageViewerRoot',
      provide() {
        return {
          store: commitDiffDiscussionsStore,
          userPermissions: appData.userPermissions,
          endpoints: {
            discussions: appData.discussionsEndpoint,
            previewMarkdown: appData.previewMarkdownEndpoint,
            markdownDocs: appData.markdownDocsEndpoint,
            register: appData.registerPath,
            signIn: appData.signInPath,
            reportAbuse: appData.reportAbusePath,
          },
          noteableType: appData.noteableType,
        };
      },
      component: ImageViewer,
      props: {
        imageData,
        oldPath,
        newPath,
        diffRefs,
      },
    });
  },
};
